export default __webpack_public_path__ + "static/Violet_sky-ed78138e8fe8d29c5f07e36d6c91a4d1.png";